<div class="login-popup-main {{admin}}">
    <div class="login-popup">
        <div class="mat-dialog-actions" mat-dialog-actions [align]="selectedAlign">
            <button mat-button mat-dialog-close><mat-icon>close</mat-icon></button>
        </div>
        <div class="forgot-password-container">
            <div class="title-container">
                <div class="title">
                    <h3>{{'login.forgotPassword' | translate | uppercase}}</h3>
                </div>
            </div>
            <form *ngIf="dataDialog.verificationUuid!==''" [formGroup]="forgotPasswordForm!" novalidate>
                <div class="username-password">
                    <div class="password-container">
                        <div class="password">
                            <label>{{'login.newPassword' | translate}}</label>
                            <input
                                formControlName="password"
                                class="form-control"
                                required
                                [ngStyle]="forgotPasswordForm!.controls['password'].invalid && (forgotPasswordForm!.controls['password'].dirty ||forgotPasswordForm!.controls['password'].touched) && forgotPasswordForm!.controls['password'].errors?.['required'] && {'border':'1px solid red'}"
                                autofocus
                                type="password"
                                name="new_password"
                                id="new_password"
                                autocomplete="new-password"
                            /><br />
                            <div
                                *ngIf="forgotPasswordForm!.controls['password'].invalid && (forgotPasswordForm!.controls['password'].dirty || forgotPasswordForm!.controls['password'].touched)"
                                class="alert-password"
                            >
                                <div *ngIf="forgotPasswordForm!.controls['password'].errors?.['required']">
                                    <small>{{ 'login.passwordRequired' | translate }}</small>
                                </div>
                                <small class="text-danger" *ngIf="forgotPasswordForm!.get('password')!.hasError('pattern')">
                                    A jelszónak tartalmaznia kell kis-és nagybetűt és számot! '%' jelet nem.
                                </small>
                            </div>
                        </div>
                        <div class="password-confirm">
                            <label>{{'login.newpasswordConfirm' | translate}}</label>
                            <input
                                formControlName="passwordConfirm"
                                name="confirm_new_password"
                                id="confirm_new_password"
                                autocomplete="new-password"
                                class="form-control"
                                required
                                [ngStyle]="forgotPasswordForm!.controls['passwordConfirm'].invalid && (forgotPasswordForm!.controls['passwordConfirm'].dirty ||forgotPasswordForm!.controls['passwordConfirm'].touched) && forgotPasswordForm!.controls['passwordConfirm'].errors?.['required'] && {'border':'1px solid red'}"
                                autofocus
                                type="password"
                            /><br />
                            <div
                                *ngIf="forgotPasswordForm!.controls['passwordConfirm'].invalid && (forgotPasswordForm!.controls['passwordConfirm'].dirty || forgotPasswordForm!.controls['passwordConfirm'].touched)"
                                class="alert-password"
                            >
                                <div *ngIf="forgotPasswordForm!.controls['passwordConfirm'].errors?.['required']">
                                    <small>{{ 'login.passwordRequired' | translate }}</small>
                                </div>
                            </div>
                            <small [ngStyle]="{'color': 'red'}" *ngIf="forgotPassword!==forgotPasswordConfirm"
                                >{{forgotPasswordsAreNotEqual}}</small
                            >
                        </div>
                    </div>
                </div>
            </form>
            <div *ngIf="dataDialog.verificationUuid!==''" class="send-button">
                <button (click)="updatePassword()" [disabled]="!forgotPasswordForm?.valid">{{'login.send' | translate}}</button>
            </div>
            <form *ngIf="dataDialog.verificationUuid===''" [formGroup]="forgotPasswordVerificationForm!" novalidate>
                <div class="username-password">
                    <label>{{'login.email' | translate}}</label>
                    <input
                        formControlName="email"
                        id="email"
                        class="form-control"
                        type="email"
                        required
                        [ngStyle]="forgotPasswordVerificationForm!.controls['email'].invalid && (forgotPasswordVerificationForm!.controls['email'].dirty ||forgotPasswordVerificationForm!.controls['email'].touched) && forgotPasswordVerificationForm!.controls['email'].errors?.['required'] && {'border':'1px solid red'}"
                        autofocus
                        name="email"
                        autocomplete="email"
                    /><br />
                    <div
                        *ngIf="forgotPasswordVerificationForm!.controls['email'].invalid && (forgotPasswordVerificationForm!.controls['email'].dirty || forgotPasswordVerificationForm!.controls['email'].touched)"
                        class="alert-email"
                    >
                        <div *ngIf="forgotPasswordVerificationForm!.controls['email'].errors?.['required']">
                            <small>{{ 'login.emailRequired' | translate }}</small>
                        </div>
                        <small class="text-danger" *ngIf="forgotPasswordVerificationForm!.get('email')!.hasError('pattern')">
                            Helyes email formátum: "info@gmail.com".
                        </small>
                    </div>
                </div>
            </form>
            <div *ngIf="dataDialog.verificationUuid===''" class="send-button">
                <button (click)="sendVerificationUuid()" [disabled]="!forgotPasswordVerificationForm?.valid">{{'login.send' | translate}}</button>
            </div>
        </div>
    </div>
</div>
